function makeQueryParams(dict){
    if(dict){
        return '?' + Object.entries(dict).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    } else {
        return '';
    }
    
}

class API{

    constructor(url){
        this.endpoint = url; 
    }
    async fetch(queryString, opts = {}, method='GET'){
        const url = this.endpoint+queryString+makeQueryParams(opts.query);
        const headers = {}

        if(localStorage.girderToken){
            headers['Girder-Token'] = localStorage.girderToken;
        }

        if(opts.headers){
            for(const key in opts.headers){
                headers[key] = opts.headers[key]; 
            }
        }
        const responseType = opts.responseType || 'json';
        let body = opts.body;
        if(body && !(body instanceof FormData)){
            delete headers['Content-Type']
            const fd = new FormData();
            for(const key in body){
                const val = typeof body[key] === 'string' ? body[key] : JSON.stringify(body[key]);
                fd.append(key, val)
            }
            body = fd;
        }
        // if json is passed in instead of body, use application/json as the content-type
        if(!body && opts.json){
            headers['Content-Type'] = 'application/json';
            body = typeof opts.json === 'string' ? opts.json : JSON.stringify(opts.json)
        }

        const fetchOpts = { headers, method, body };
        if (opts.cache !== undefined) fetchOpts.cache = opts.cache;
        let result = window.fetch(url, fetchOpts);


        if(opts.log){
            result.then(r => console.log(r));
        }
        const output = {}
        return result.then(resp => {
            output.status = resp.status;
            output.headers = Object.fromEntries(resp.headers.entries());
            if(resp.status == 200){
                if(responseType == 'text') {
                    return resp.text();
                } else if (responseType == 'json'){
                    return resp.json();
                } else if (responseType == 'blob'){
                    return resp.blob();
                }
            } else {
                // Attempt to parse JSON error response (Girder returns JSON for RestException)
                // Fall back to statusText if parsing fails
                return resp.text().then(text => {
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        // Not JSON, return statusText as before
                        return resp.statusText;
                    }
                });
            }

        }).then(text => {
            output.data = text;
            return output;
        })
            
    }

    async get(queryString, opts){
        return this.fetch(queryString, opts, 'GET');
    }
    async post(queryString, opts){
        return this.fetch(queryString, opts, 'POST');
    }
    async put(queryString, opts){
        return this.fetch(queryString, opts, 'PUT');
    }
    async delete(queryString, opts){
        return this.fetch(queryString, opts, 'DELETE');
    }
    url(path, opts={}){
        const normalizedPath = (path && path.charAt(0) === '/') ? path.slice(1) : path;
        return this.endpoint + normalizedPath + makeQueryParams(opts.query);
    }
}

const api = new API('/dsa/api/v1/'); // TODO: make this configurable via environment variable?

export default api;